var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSocialLinkedin = function SvgIconSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M5.88 17.24V7.537H2.658v9.703h3.223ZM4.27 6.212c1.123 0 1.823-.745 1.823-1.676-.021-.952-.7-1.677-1.802-1.677s-1.823.725-1.823 1.677c0 .931.7 1.676 1.78 1.676h.022ZM7.664 17.24h3.222v-5.418c0-.29.021-.58.106-.787.233-.58.763-1.18 1.654-1.18 1.165 0 1.632.89 1.632 2.194v5.19H17.5v-5.563c0-2.98-1.59-4.367-3.71-4.367-1.738 0-2.501.973-2.925 1.635h.021V7.537H7.664c.042.91 0 9.703 0 9.703Z"
  })));
};
export default SvgIconSocialLinkedin;